"use strict";

var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _focus = require("@react-aria/focus");
var _arrayUtils = require("../../../shared/array-utils");
var _typeUtil = require("../../../shared/type-util");
var _Text = _interopRequireDefault(require("../../../components/text/Text"));
var _Icon = require("../../../components/media/icon/Icon");
var _DropdownList = _interopRequireDefault(require("../../../components/controls/dropdown/DropdownList"));
var _jsxRuntime = require("react/jsx-runtime");
var BulkSelectorWrapper = _styledComponents.default.div.withConfig({
  displayName: "BulkSelector__BulkSelectorWrapper",
  componentId: "sc-6f0srx-0"
})(["bottom:", ";position:fixed;width:95%;max-width:840px;left:50%;transform:translateX(-50%);"], function (_ref) {
  var bottomOffset = _ref.bottomOffset,
    theme = _ref.theme;
  return bottomOffset ? "calc(".concat(theme.sys.spacing['600'], " + ").concat(bottomOffset, "px)") : theme.sys.spacing['600'];
});
var BulkSelectorStyle = _styledComponents.default.div.withConfig({
  displayName: "BulkSelector__BulkSelectorStyle",
  componentId: "sc-6f0srx-1"
})(["display:flex;justify-content:space-between;background-color:", ";box-shadow:", ";border-radius:", ";padding:", " ", ";gap:", ";"], function (props) {
  return props.theme.comp.bulkselector.color.background.default;
}, function (props) {
  return props.theme.sys.elevation.shadow['1'];
}, function (props) {
  return props.theme.sys.size.borderradius['3'];
}, function (props) {
  return props.theme.sys.spacing['100'];
}, function (props) {
  return props.theme.sys.spacing['600'];
}, function (props) {
  return props.theme.sys.spacing['400'];
});
var DarkButtonStyle = _styledComponents.default.button.withConfig({
  displayName: "BulkSelector__DarkButtonStyle",
  componentId: "sc-6f0srx-2"
})(["cursor:pointer;padding:", ";color:", ";background-color:", ";border:none;border-radius:", ";", ";line-height:20px;white-space:nowrap;& :not(.fixed-colors) > svg{path{fill:", ";}}outline:none;&.focus-ring{box-shadow:0 0 0 ", " ", ";}&:hover{color:", ";background-color:", ";& :not(.fixed-colors) > svg{path{fill:", ";}}}&:active{color:", ";background-color:", ";& :not(.fixed-colors) > svg{path{fill:", ";}}}", ""], function (props) {
  return props.theme.sys.spacing['300'];
}, function (props) {
  return props.theme.comp.bulkselector.color.text.default;
}, function (props) {
  return props.theme.comp.bulkselector.color.background.default;
}, function (props) {
  return props.theme.sys.size.borderradius['2'];
}, function (props) {
  return props.theme.comp.button.font.standard;
}, function (props) {
  return props.theme.comp.bulkselector.color.text.default;
}, function (props) {
  return props.theme.sys.size.borderwidth.thick;
}, function (props) {
  return props.theme.comp.bulkselector.color.border.focusring;
}, function (props) {
  return props.theme.comp.bulkselector.color.text.hover;
}, function (props) {
  return props.theme.comp.bulkselector.color.background.hover;
}, function (props) {
  return props.theme.comp.bulkselector.color.text.hover;
}, function (props) {
  return props.theme.comp.bulkselector.color.text.pressed;
}, function (props) {
  return props.theme.comp.bulkselector.color.background.pressed;
}, function (props) {
  return props.theme.comp.bulkselector.color.text.pressed;
}, function (_ref2) {
  var disabled = _ref2.disabled,
    theme = _ref2.theme;
  return disabled && (0, _styledComponents.css)(["pointer-events:none;color:", ";"], theme.sys.color.text.disabled.ondisabled);
});
var StandardGroup = _styledComponents.default.div.withConfig({
  displayName: "BulkSelector__StandardGroup",
  componentId: "sc-6f0srx-3"
})(["display:flex;flex-direction:row;align-items:center;gap:", ";"], function (props) {
  return props.theme.sys.spacing['100'];
});
var ActionGroup = _styledComponents.default.div.withConfig({
  displayName: "BulkSelector__ActionGroup",
  componentId: "sc-6f0srx-4"
})(["display:flex;flex-direction:row;align-items:center;gap:", ";"], function (props) {
  return props.theme.sys.spacing['400'];
});
var DarkButton = /*#__PURE__*/_react.default.forwardRef(function (_ref3, ref) {
  var children = _ref3.children,
    rest = _objectWithoutProperties(_ref3, ["children"]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_focus.FocusRing, {
    focusRingClass: "focus-ring",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(DarkButtonStyle, _objectSpread({
      ref: ref
    }, rest, {
      children: children
    }))
  });
});
var MainAction = function MainAction(_ref4) {
  var onClick = _ref4.onClick,
    dataCy = _ref4['data-cy'],
    disabled = _ref4.disabled,
    children = _ref4.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(DarkButton, {
    onClick: onClick,
    "data-cy": dataCy,
    disabled: disabled,
    children: children
  });
};
var ExtraAction = function ExtraAction(_ref5) {
  var onClick = _ref5.onClick,
    dataCy = _ref5['data-cy'],
    children = _ref5.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DropdownList.default.Item, {
    onClick: onClick,
    "data-cy": dataCy,
    children: children
  });
};
var BulkSelector = function BulkSelector(_ref6) {
  var show = _ref6.show,
    label = _ref6.label,
    bottomOffset = _ref6.bottomOffset,
    onClear = _ref6.onClear,
    children = _ref6.children;
  var _ref7 = (0, _react.useMemo)(function () {
      return show ? (0, _arrayUtils.partitionArray)(children, function (child) {
        return (0, _typeUtil.isType)(child, MainAction);
      }) : [[], []];
    }, [children, show]),
    _ref8 = _slicedToArray(_ref7, 2),
    mainActions = _ref8[0],
    extraActions = _ref8[1];
  if (!show) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(BulkSelectorWrapper, {
    bottomOffset: bottomOffset,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(BulkSelectorStyle, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(StandardGroup, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          color: 'ondark',
          noWrap: true,
          children: label
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(DarkButton, {
          onClick: onClear,
          "aria-label": 'Clear Selection',
          "data-cy": 'clear-selection',
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
            icon: 'close',
            newColor: 'ondark'
          })
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(ActionGroup, {
        children: [mainActions, extraActions.length > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_DropdownList.default, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_DropdownList.default.Trigger, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(DarkButton, {
              "aria-label": 'Show more actions',
              "data-cy": 'extra-actions',
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
                icon: 'more',
                newColor: 'ondark'
              })
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DropdownList.default.Content, {
            offset: 10,
            children: extraActions.filter(function (action) {
              return !action.props.hidden;
            })
          })]
        }) : undefined]
      })]
    })
  });
};
BulkSelector.MainAction = MainAction;
BulkSelector.ExtraAction = ExtraAction;
var _default = exports.default = BulkSelector;